import React from 'react';
import { type VariantProps } from 'class-variance-authority';
import useFeatureToggleService from 'feature-toggle';
import { ShadcnBadge, badgeVariants } from 'shadcn-ui';
import { SimpleBlock } from 'ui-builder';

import styles from './TextBadge.module.scss';

export enum TextBadgeStyle {
  DRAFT = 'draft',
  INACTIVE = 'inactive',
  ACTIVE = 'active',
}

type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>;

const VARIANT_MAP: Record<TextBadgeStyle, BadgeVariant> = {
  [TextBadgeStyle.ACTIVE]: 'active',
  [TextBadgeStyle.DRAFT]: 'draft',
  [TextBadgeStyle.INACTIVE]: 'inactive',
};

function LegacyTextBadge(props: { text: string; style?: TextBadgeStyle }) {
  const style = props.style || TextBadgeStyle.ACTIVE;

  return (
    <SimpleBlock className={`${styles.badge} ${styles[style.toLowerCase()]}`}>
      {props.text}
    </SimpleBlock>
  );
}

export function TextBadge(props: {
  text: string,
  style?: TextBadgeStyle,
}) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    const resolvedStyle = props.style || TextBadgeStyle.ACTIVE;
    return (
      <ShadcnBadge variant={VARIANT_MAP[resolvedStyle]}>
        {props.text}
      </ShadcnBadge>
    );
  } else {
    return <LegacyTextBadge {...props} />;
  }
}
